import { INotificationModel } from "@xala/common-services";

export type NotificationField =
  | "Name"
  | "NamePreview"
  | "TypeDisplayName"
  | "Provider"
  | "ProviderDisplayName"
  | "Priority"
  | "PriorityDisplayName"
  | "ScheduledOn"
  | "TextContent"
  | "TextContentPreview"
  | "ImageUrl"
  | "ImageAbsoluteUrl"
  | "ImageFile"
  | "UrlContent"
  | "UrlDescription"
  | "DataType"
  | "DataContent"
  | "CreatorUserId"
  | "CreatorUserFullName"
  | "CreatorAvatarUrl"
  | "CreatorProfiles"
  | "Created"
  | "LastModificationUserId"
  | "LastModificationUserFullName"
  | "LastModification"
  | "Status"
  | "StatusDisplayName"
  | "RecipientType"
  | "RecipientTypeDisplayName"
  | "Recipients"
  | "BusinessUnitCountries"
  | "SelectAsset"
  | "Title"
  | "DeepLinkUrl"
  | "NotificationProviderSegments";

  const requiredFields: NotificationField[] = [
    "Name",
    "Title",
    "RecipientType",
  ];

  export const checkRequiredFields = (
    data: INotificationModel,
    openNotification: (message: string) => void
  ) => {
    const missingFields: string[] = [];
    for (const field of requiredFields) {
      if (!data[field as keyof INotificationModel]) {
        missingFields.push(field);
      }
    }

    if (data.RecipientType === "SELECTED_USERS" && !data.Recipients) {
      missingFields.push("Recipients");
    }

    if (data.RecipientType === "SEGMENTS_USERS" && !data.SegmentId) {
      missingFields.push("Segment");
    }

    if (missingFields.length > 0) {
      openNotification(`This fields are required: ${missingFields.join(', ')}.`);
      return false;
    }

    return true;
  };

  export const processImageUrl = (url?: string): string | undefined => {
    if (!url) {
      return url;
    }
    if (url.includes("Tenant_1/Asset/") && !url.includes("/Notification")) {
      return url.replace("Tenant_1/Asset/", "Notification/Tenant_1/Asset/");
    }
    return url;
  };
